<div [ngClass]="isMobile ? 'isMobile gap-24' : 'd-flex flex-wrap gap-x-24 align-items-center'" class="promoCode_container ">
  <!---------------------------------------- Affiche le prix de base ---------------------------------------------------->
  <h6 class="mb-2 text_4 d-flex w-100 align-items-sm-center">
    {{ informationKey | translate }}
    <button (click)="clearPromoCode()" *ngIf="(isMobile && screenWidth > 380) && promoCodeData.submit && promoCodeData.success"
      aria-label="Clear"
      class="btn m-0 ms-auto p-0 border-0">
      <mat-icon class="font-14 d-flex align-items-center justify-content-center mediumGray">close</mat-icon>
    </button>
  </h6>
  <h6 [ngClass]="promoCodeData.success ? 'strike title_1' : 'align-self-center'" class="mb-0 price text-nowrap">
    {{ (itemPrice | number: '1.0-2') + ' €' }}
  </h6>

  <!-------------------------------------- loader -------------------------------------------->
  <div *ngIf="promoCodeData.loading" class="flex-grow-1 d-flex align-items-center justify-content-center">
    <div class="spinner-border text-primary"></div>
  </div>

  <!------------------------- affiche l'effet du code promo et le montant restant à payer ------------------------------->
  <ng-container *ngIf="promoCodeData.submit && promoCodeData.success">
    <div class="title_2 mediumGray d-flex align-items-center pt-2 pt-sm-0">
      {{ "-" + (promoCodeData.obj.reduction) + (promoCodeData.obj.reductionType === 'percent' ? '&#x25;' : ' €') }}
      <button (click)="clearPromoCode()" *ngIf="!isMobile || screenWidth <= 380" aria-label="Clear" class="btn m-0 p-0 border-0">
        <mat-icon class="font-14 d-flex align-items-center justify-content-center mediumGray">close</mat-icon>
      </button>
    </div>
    <span class="price pt-3 pb-4 pt-sm-0 pb-sm-0 text-nowrap">
      {{ (price | number: '1.0-2') + ' €' }}
    </span>

  </ng-container>


  <!--------------------------------------- Input de code promo --------------------------------------------------------->
  <div [ngClass]="{'pt-2': !isMobile}" class="pb-4 input_container" *ngIf="!promoCodeData.submit || (promoCodeData.submit && promoCodeData.error)">
    <div
      class="d-flex flex-row gap-16 align-items-center">
      <mat-form-field>
        <mat-label
          class="subtitle_1 text-black">{{ 'PROCESSES.ACCOMMODATION.PAYMENT.PROMO_CODE' | translate }}</mat-label>
        <input [(ngModel)]="codePromoValue" class="text_3" matInput type="text">
      </mat-form-field>

      <button (click)="checkPromoCode()" aria-label="Check promo code" class="btn btn-lf-secondary p-2 subtitle_2" [disabled]="!codePromoValue || codePromoValue.length == 0">
        {{ 'COMMON.ADD_PROMO_CODE' | translate}}
      </button>

    </div>
    <p *ngIf="promoCodeData['error']" class="text-danger minitext_2">
      {{ "PROCESSES.ACCOMMODATION.PAYMENT.CODE_NOT_FOUND" | translate }}
    </p>

  </div>

</div>
